import React from 'react';
import { useInView } from './useInView';
import './Skills.css';

const categories = [
  {
    label: 'Languages',
    icon: '⌨️',
    skills: [
      { name: 'Java', level: 90 }, { name: 'JavaScript', level: 80 },
      { name: 'Python', level: 65 }, { name: 'C / C++', level: 60 }
    ]
  },
  {
    label: 'Backend',
    icon: '⚙️',
    skills: [
      { name: 'Spring Boot', level: 85 }, { name: 'Node.js', level: 75 },
      { name: 'Express.js', level: 72 }, { name: 'REST APIs', level: 88 }
    ]
  },
  {
    label: 'Frontend',
    icon: '🎨',
    skills: [
      { name: 'React.js', level: 82 }, { name: 'HTML5 / CSS3', level: 85 },
      { name: 'JavaScript ES6+', level: 80 }
    ]
  },
  {
    label: 'Databases & Tools',
    icon: '🗄️',
    skills: [
      { name: 'MySQL', level: 82 }, { name: 'MongoDB', level: 65 },
      { name: 'Git & GitHub', level: 88 }, { name: 'Postman', level: 80 }
    ]
  }
];

export default function Skills() {
  const [ref, visible] = useInView();

  return (
    <section className="section" id="skills">
      <div ref={ref} className={`fade-in${visible ? ' visible' : ''}`}>
        <p className="section-label">Skills</p>
        <h2 className="section-title">My technical arsenal.</h2>
        <div className="skills-grid">
          {categories.map((cat, ci) => (
            <div key={ci} className="skill-category" style={{ animationDelay: `${ci * 0.1}s` }}>
              <div className="cat-header">
                <span className="cat-icon">{cat.icon}</span>
                <span className="cat-label">{cat.label}</span>
              </div>
              <div className="skill-bars">
                {cat.skills.map((s, si) => (
                  <div key={si} className="skill-bar-item">
                    <div className="skill-meta">
                      <span className="skill-name">{s.name}</span>
                      <span className="skill-pct">{s.level}%</span>
                    </div>
                    <div className="bar-track">
                      <div
                        className="bar-fill"
                        style={{ width: visible ? `${s.level}%` : '0%', transitionDelay: `${si * 0.1 + ci * 0.1}s` }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className="certs">
          <p className="section-label" style={{ marginBottom: 24 }}>Certifications</p>
          <div className="cert-list">
            {[
              { title: 'Full Stack Web Development', org: 'Apna College', year: '2025', icon: '🎓' },
              { title: 'AWS Cloud Fundamentals', org: 'Amazon Web Services', year: '2024', icon: '☁️' },
              { title: 'Technology Job Simulation', org: 'Deloitte × Forage', year: '2024', icon: '💼' }
            ].map((c, i) => (
              <div key={i} className="cert-card">
                <span className="cert-icon">{c.icon}</span>
                <div>
                  <div className="cert-title">{c.title}</div>
                  <div className="cert-meta">{c.org} · {c.year}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
